import kynwardLogo from '../../../assets/images/kynward-mark.png';

import './siteDownPage.css';

/**
 * In-app fallback when React can still render but the experience should show “site down”.
 */
export function SiteDownPage() {
  return (
    <div className="kyn-down">
      <div className="kyn-down__glow" aria-hidden />
      <div className="kyn-down__vignette" aria-hidden />
      <main className="kyn-down__panel" role="main">
        <div className="kyn-down__logo">
          <img src={kynwardLogo} width={72} height={72} alt="Kynward" decoding="async" />
        </div>
        <p className="kyn-down__eyebrow">We&rsquo;ll be right back</p>
        <h1 className="kyn-down__title">Kynward is taking a short pause</h1>
        <p className="kyn-down__body">
          Our site is temporarily unavailable. Please check back in a few minutes&mdash;real
          connection is worth the wait.
        </p>
        <p className="kyn-down__hint">If this keeps happening, try again later today.</p>
      </main>
    </div>
  );
}
